import { Button, TextField } from "@mui/material";
import { message } from "antd";
import { useState } from 'react';

export default function Filters({setDateStartFilter,setIdOrderFilter,setClientFilter,setColorFilter,setRefFilter,filterOrders,cleanFilterOrders}){
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);

    const toggleAccordion = () => {
        setIsAccordionOpen(!isAccordionOpen);
    };

    return(
        <div style={{ flexDirection: 'column'}}>

            <Button
                style={{ marginBottom: '15px' }}
                variant="contained"
                size="small"
                onClick={toggleAccordion}
            >
                {isAccordionOpen ? 'Cerrar Filtros' : 'Abrir Filtros'}
            </Button>

            {isAccordionOpen && (
                <div style={{ display: 'flex', flexDirection: 'row', margin: '20px 0px' }}>
                    
                    <TextField
                        style={{ marginRight: '15px'}}
                        label="Numero de orden"
                        onChange={(e)=>{
                            setIdOrderFilter(e.target.value);
                        }}
                        type="text"
                        id="idOrder"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        style={{ marginRight: '15px'}}
                        label="Cliente"
                        onChange={(e)=>{
                            setClientFilter(e.target.value);
                        }}
                        type="text"
                        id="clientOrder"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        style={{ marginRight: '15px'}}
                        label="Color"
                        onChange={(e)=>{
                            setColorFilter(e.target.value);
                        }}
                        type="text"
                        id="colorOrder"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />

                    <TextField
                        style={{ marginRight: '15px'}}
                        label="Referencia"
                        onChange={(e)=>{
                            setRefFilter(e.target.value);
                        }}
                        type="text"
                        id="refProduct"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />

                    <Button
                        style={{ marginLeft: '15px', marginTop: "10px" }}
                        variant="contained"
                        size="small"
                        onClick={() => {
                            try {
                                filterOrders();
                            } catch (error) {
                                message.error(error.message); 
                            }
                        }}
                    >
                        Filtrar
                    </Button>
                    <Button
                        style={{ marginLeft: '15px', marginTop: "10px" }}
                        variant="contained"
                        size="small"
                        onClick={() => {
                            cleanFilterOrders()
                        }}
                    >
                        Limpiar filtro
                    </Button>
                    
                </div>
            )}
        </div>
    );
   
}
